module.exports = __webpack_public_path__ + "static/media/audition-img-4.b50d9bb5.png";